<template>
    <div class="acomodar">
        <!-- -->
        <Control_Procesos_Fac></Control_Procesos_Fac>
    </div>
</template>

<script>
import Control_Procesos_Fac from '@/components/ModContabilidad/Control_Procesos_Fac.vue';
export default {
    name: 'CopiasControlProcesos',
    components: {
        Control_Procesos_Fac
    },

    data() {
        return {

        };
    },

    mounted() {

    },

    methods: {

    },
};
</script>

<style scoped>
.acomodar {
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    margin-top: 1%;
    margin-bottom: 1%;
    padding-bottom: 2%;
    width: 100%;
    background: rgb(255, 255, 255);
    margin-left: 1%;
    margin-right: 1%;
    height: auto;
    border-radius: 10px 10px 10px 10px;
    overflow-x: hidden;
    overflow-y: hidden;
}
</style>